import { render, staticRenderFns } from "./MultiOrgMenu.vue?vue&type=template&id=5f0b7507&"
import script from "./MultiOrgMenu.vue?vue&type=script&lang=js&"
export * from "./MultiOrgMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultiOrgMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
